import clsx from "clsx";
import React, { FunctionComponent } from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { CardContainer } from "../../../../../components";
import TooltipWrapper from "../../../../../enhancers/TooltipWrapper";
import { LAYOUT_TYPE } from "../reanalyze-form-input/ReanalyzeFormInput";
import styles from "./reanalyze-card-container.module.scss";

type ReanalyzeCardContainerProps = {
  classNameOuterContainer?: string;
  classNameInnerContainer?: string;
  disabled?: boolean;
  selected?: boolean;
  hoverable?: boolean;
  layout?: string;
  hidden?: boolean;
  tooltipMessage?: string;
  onClick?: () => void;
};

const getSpacings = (layout?: string) => {
  if (layout === LAYOUT_TYPE.NONE) {
    return null;
  } else if (layout === LAYOUT_TYPE.COL) {
    return "p-10 border-1";
  } else {
    return "px-20 py-15 border-1";
  }
};

function getCursorClass(
  onClick: (() => void) | undefined,
  disabled: boolean | undefined
) {
  if (disabled) {
    return "cursor-not-allowed";
  }
  return onClick ? "cursor-pointer" : "cursor-default";
}

const ReanalyzeCardContainer: FunctionComponent<
  ReanalyzeCardContainerProps
> = ({
  classNameOuterContainer,
  classNameInnerContainer,
  disabled,
  selected,
  hoverable,
  layout,
  children,
  hidden,
  tooltipMessage,
  onClick
}) => {
  if (hidden) {
    return null;
  }

  return (
    <TooltipWrapper
      condition={tooltipMessage != null}
      wrapper={(_children: React.ReactNode) => (
        <OverlayTrigger
          overlay={<Tooltip>{tooltipMessage}</Tooltip>}
          placement="top"
        >
          <div>{_children}</div>
        </OverlayTrigger>
      )}
    >
      <CardContainer
        classNameOuterContainer={clsx("mb-10", classNameOuterContainer)}
        classNameInnerContainer={clsx(
          getSpacings(layout),
          getCursorClass(onClick, disabled),
          {
            "background-color-disabled": disabled,
            "border border-primary": selected
          },
          styles.reanalyze_card_inner_container,
          classNameInnerContainer
        )}
        hoverable={hoverable}
        onClick={onClick}
      >
        {children}
      </CardContainer>
    </TooltipWrapper>
  );
};

export default ReanalyzeCardContainer;
